import React from "react";
import { ReactComponent as IconBr } from "../assets/images/flags/br.svg";
import { ReactComponent as IconUsa } from "../assets/images/flags/usa.svg";
import { ReactComponent as IconPlay } from "../assets/images/icons/icon_play.svg";
import { ReactComponent as IconSac } from "../assets/images/icons/icon_sac.svg";
import { ReactComponent as IconSearch } from "../assets/images/icons/icon_search.svg";
import { ReactComponent as IconSound } from "../assets/images/icons/icon_sound.svg";
import { ReactComponent as IconEdit } from "../assets/images/icons/icon_edit.svg";
import { ReactComponent as IconPrint } from "../assets/images/icons/icon_print.svg";
import { ReactComponent as IconBin } from "../assets/images/icons/icon_bin.svg";
import { ReactComponent as IconCalendar } from "../assets/images/icons/icon_calendar.svg";

import * as icons from "../constants/buttons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInfo, faUserPlus, faUsers } from "@fortawesome/free-solid-svg-icons";

export const getIcon = (iconType = null, classes = " ") => {
  if (iconType)
    switch (iconType) {
      case icons.BTN_FLAG_BR:
        return (
          <span className={classes}>
            <IconBr />
          </span>
        );
      case icons.BTN_FLAG_USA:
        return (
          <span className={classes}>
            <IconUsa />
          </span>
        );
      case icons.BTN_ICON_PLAY:
        return (
          <span className={classes}>
            <IconPlay />
          </span>
        );
      case icons.BTN_ICON_SAC:
        return (
          <span className={classes}>
            <IconSac />
          </span>
        );
      case icons.BTN_ICON_SEARCH:
        return (
          <span className={classes}>
            <IconSearch />
          </span>
        );
      case icons.BTN_ICON_SOUND:
        return (
          <span className={classes}>
            <IconSound />
          </span>
        );
      case icons.BTN_ICON_ADD_USER:
        return (
          <span className={classes}>
            <FontAwesomeIcon icon={faUserPlus} />
          </span>
        );
      case icons.BTN_ICON_ADD_MANY_USERS:
        return (
          <span className={classes}>
            <FontAwesomeIcon icon={faUsers} />
          </span>
        );
      case icons.BTN_ICON_INFO:
        return (
          <span className={classes}>
            <FontAwesomeIcon icon={faInfo} />
          </span>
        );
      case icons.BTN_ICON_EDIT:
        return (
          <span className={classes}>
            <IconEdit />
          </span>
        );
      case icons.BTN_ICON_PRINT:
        return (
          <span className={classes}>
            <IconPrint />
          </span>
        );
      case icons.BTN_ICON_BIN:
        return (
          <span className={classes}>
            <IconBin />
          </span>
        );
      case icons.BTN_ICON_CALENDAR:
        return (
          <span className={classes}>
            <IconCalendar />
          </span>
        );

      default:
        return <span className={classes}>{iconType}</span>;
    }
};
